module.exports = __webpack_public_path__ + "fonts/DM_Sans-800-latin17.3ccd9ab.woff2";